import { Node, NodeType } from '@tiptap/pm/model'

type FindNodeResult = {
  node: Node
  pos: number
}

export const findNodesOfType = (
  doc: Node,
  type: NodeType
): FindNodeResult[] => {
  const result: FindNodeResult[] = []
  doc.descendants((node, pos) => {
    if (node.type === type) {
      result.push({ node, pos })
    }
    return false
  })

  return result
}

export const findNodeOfType = (
  doc: Node,
  type: NodeType
): FindNodeResult | null => {
  const [result] = findNodesOfType(doc, type)
  return result ?? null
}
